/**
 * Industrial-ui (https://vue.industrial-ui.com) configuration of the UI components
 */
const config = {
  transitions: {
    flyFade: {
      name: 'flyFade',
      effectReference: 'fly',
      animation: {
        x: 2,
        y: 2,
        duration: 200,
      },
    },
    flyIn: {
      name: 'flyIn',
      effectReference: 'fly',
      animation: {
        type: 'only-in',
        easing: 'easeIn',
        x: 2,
        y: 2,
        duration: 150,
      },
    },
  },

  components: {
    dropdown: {
      transition: 'flyFade',
      isProperties: {
        'no-padding': 'ui-dd no-padding',
      },
      class: 'w-dropdown',
      openClass: 'w--open',
      triggerClass: 'w-dropdown-toggle w--open',
      dropdownClass: 'w-dropdown-list w--open',
      disabledClass: 'dropdown-disabled',
    },

    modal: {
      transition: 'fade',
      class: 'popup-flex',
      openClass: '',
      closeClass: '',

      overlayClass: 'popup',
      openOverlayClass: 'popup-open',
      closeOverlayClass: '',

      bodyClass: '',
      openBodyClass: 'popup--open',
      closeBodyClass: '',
    },
  },
};

export default config;
